import { COLOR_PALETTE, COLORS } from './colors';
import { Theme } from './types';

export const darkTheme: Theme = {
    colors: COLORS,
    semantic: {
        primary: COLOR_PALETTE.primary.p50,
        primaryLight: COLOR_PALETTE.neutral.p70,
        primaryHover: COLOR_PALETTE.primary.p70,
        onPrimary: COLORS.white,
        primaryContainer: COLOR_PALETTE.primary.p40,
        primaryContainerHover: COLOR_PALETTE.primary.p60,
        onPrimaryContainer: COLORS.white,
        infoContainerLight: COLOR_PALETTE.neutral.p80,
        successContainerLight: COLOR_PALETTE.green.p80,
        successLight: COLOR_PALETTE.green.p70,
        errorContainer: COLOR_PALETTE.red.p80,

        secondary: COLOR_PALETTE.secondary.p50,
        secondaryHover: COLOR_PALETTE.secondary.p60,
        onSecondary: COLOR_PALETTE.secondary.p90,

        textPrimary: COLOR_PALETTE.neutral.p20,
        textDisabled: COLOR_PALETTE.neutral.p40,
        border: COLOR_PALETTE.neutral.p60,
        skeleton: COLOR_PALETTE.neutral.p70,

        body: COLOR_PALETTE.neutral.p90,
        neutral: COLOR_PALETTE.neutral.p50,
        onNeutral: COLORS.white,
        background: COLOR_PALETTE.neutral.p85,
        backgroundLight: COLOR_PALETTE.neutral.p80,
        onBackground: COLOR_PALETTE.neutral.p20,
        surface: COLOR_PALETTE.neutral.p85,
        onSurface: COLORS.white,

        divider: COLOR_PALETTE.neutral.p60,
        disabled: COLOR_PALETTE.neutral.p60,

        error: COLOR_PALETTE.red.p45,
        onError: COLORS.white,
        success: COLOR_PALETTE.green.p70,
        onSuccess: COLORS.white,
        warning: COLOR_PALETTE.yellow.p70,
        onWarning: COLORS.black,
        info: COLOR_PALETTE.blue.p70,
        onInfo: COLORS.white,
    },
};
